import { FormattedMessage } from "react-intl";

import SBEditable from "../../../components/sbEditable/sbEditable";
import ListingHeader from "../../../components/listingHeader/listingHeader";

import { useStoryblokTopStoriesAsideWidget } from "../../../hooks/useStoryblokTopStoriesAsideWidget";

import styles from "./topStoriesAsideWidget.module.scss";
import ArticleListingCard from "../../../components/articleListingCard/articleListingCard";

function TopStoriesAsideWidget({ blok }) {
  const [articles, isLoading] = useStoryblokTopStoriesAsideWidget();

  if (!isLoading && articles.length === 0) {
    return null;
  }

  return (
    <SBEditable blok={blok} withClass={styles.topStoriesWidget}>
      <ListingHeader>
        <h3 className={styles.headline}>
          <FormattedMessage id="component.top_stories_aside_widget.headline" />
        </h3>
      </ListingHeader>
      <ul className={styles.list}>
        {isLoading ? <div className="loader centered" /> : null}
        {articles.map((a) => (
          <li key={a.uuid}>
            <ArticleListingCard
              layout="noImage_article_type"
              date_new_line={true}
              slug={a.slug}
              thumbnail={a.content.thumbnail}
              authors={a.content.authors}
              title={a.content.headline}
              date={a.content.created_at}
              article_category={a.content.category}
              article_type={a.content.article_type}
              comment_count={5}
              enable_comments={a.content.has_comments}
              enable_social_sharing={a.content.has_social_sharing}
              use_legacy_thumbnail_background={
                a.content.legacy_thumbnail_background
              }
            />
          </li>
        ))}
      </ul>
    </SBEditable>
  );
}

export default TopStoriesAsideWidget;
